import { MediaQuery } from "svelte/reactivity";
import type { SourceSetQuery } from "../schema/SourceSetQuery.js";
import { parseSourceSet } from "../schema/utils/parseSourceSet.js";

export function createReactiveBreakpoint(breakpoint: SourceSetQuery): MediaQuery {
	return new MediaQuery(parseSourceSet(breakpoint));
}
